<template>
  <div>
    <AuBreadcrumb />
    <div class="card dao-events">
      <div class="title">
        {{ $t("daoPage.eventTitle") }}
      </div>
      <AuTable
        :columns="columns"
        :items="items"
        :loading="dataLoading"
      />
      <AuPagination
        v-if="daoEvntsTotal > itemsPerPage"
        :total-items="daoEvntsTotal"
        @pageChanged="changePage"
      />
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "DAOEvents",
  props: {
    id: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      columns: [
        { name: this.$t("daoPage.eventFirstColumn"), align: "start" },
        { name: this.$t("daoPage.eventSecondColumn"), align: "start" }
      ],
      page: 1,
      itemsPerPage: 30
    };
  },
  computed: {
    ...mapGetters({
      daoEvents: "dao/daoEvents",
      daoEventsTotal: "dao/daoEventsTotal",
      dataLoading: "dao/dataLoading"
    }),

    items() {
      return _.map(this.daoEvents, item => ({
        name: item.element.name,
        amount: item.amount
      }));
    }
  },
  async mounted() {
    const params = {
      page: this.page,
      itemsPerPage: this.itemsPerPage,
      requestId: this.id
    };
    await this.getDaoEvents(params);
  },
  methods: {
    ...mapActions({
      getDaoEvents: "dao/getDaoEvents"
    }),

    async changePage(page) {
      this.page = page;
      const params = {
        page: this.page,
        itemsPerPage: this.itemsPerPage,
        requestId: this.id
      };
      await this.getDaoEvents(params);
    }
  }
};
</script>

<style scoped lang="scss">
.dao-events{
  padding: 20px;
  .title {
    font-size: 24px;
    color: var(--text-color);
    line-height: 1.1;
    margin-bottom: 20px;
  }
}
</style>